const getLocation = (workshop) => {
  try {
    if (workshop.virtual) return "Online";
    if (workshop?.site) return workshop.site.siteName;

    if (workshop.externalSite) return workshop.externalSite;
    return "Unknown";
  } catch {
    return "Unknown";
  }
};

export default getLocation;
